export const radius = {
  sm: "0.5rem",
  md: "0.75rem",
  lg: "1rem",
  pill: "9999px",
} as const;
